import { render, staticRenderFns } from "./jxfwVip.vue?vue&type=template&id=56c915d0&scoped=true"
import script from "./jxfwVip.vue?vue&type=script&lang=js"
export * from "./jxfwVip.vue?vue&type=script&lang=js"
import style0 from "./jxfwVip.vue?vue&type=style&index=0&id=56c915d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c915d0",
  null
  
)

export default component.exports